import React from 'react';
import { SalesforcePage } from './pages/SalesforcePage';
export function App() {
  return <SalesforcePage data-id="element-0" data-mp="35ckao89f74ji" />;
}